import { apiGet, apiPost, apiPut, apiDelete } from './client'
import type { ApiResponse, FieldType, FieldOption, LookupConfig } from '@crm/shared'

export interface FieldRow {
  field_id: string
  tenant_id: string
  object_id: string
  name: string
  label: string
  type: FieldType
  is_required: number
  is_indexed: number
  default_value: string | null
  options: string | null
  config: string | null
  sort_order: number
  section: string | null
  is_system: number
  is_quick_search: number
  is_owl_visible: number
  is_template_visible: number
  created_at: string
}

export async function fetchFields(objectId: string): Promise<ApiResponse<FieldRow[]>> {
  const result = await apiGet<ApiResponse<{ fields: FieldRow[] }>>(`/objects/${objectId}/schema`)
  return { data: result.data.fields }
}

export async function createField(
  objectId: string,
  data: {
    name: string
    label: string
    type: FieldType
    is_required?: boolean
    is_indexed?: boolean
    default_value?: string
    options?: FieldOption[]
    config?: LookupConfig
    sort_order?: number
    section?: string
    is_quick_search?: boolean
    is_owl_visible?: boolean
    is_template_visible?: boolean
  },
): Promise<ApiResponse<FieldRow>> {
  return apiPost<ApiResponse<FieldRow>, typeof data>(`/objects/${objectId}/fields`, data)
}

export async function updateField(
  objectId: string,
  fieldId: string,
  data: {
    label?: string
    is_required?: boolean
    is_indexed?: boolean
    default_value?: string
    options?: FieldOption[]
    config?: LookupConfig
    sort_order?: number
    section?: string
    is_quick_search?: boolean
    is_owl_visible?: boolean
    is_template_visible?: boolean
  },
): Promise<ApiResponse<FieldRow>> {
  return apiPut<ApiResponse<FieldRow>, typeof data>(`/objects/${objectId}/fields/${fieldId}`, data)
}

export async function deleteField(objectId: string, fieldId: string): Promise<ApiResponse<{ success: boolean }>> {
  return apiDelete<ApiResponse<{ success: boolean }>>(`/objects/${objectId}/fields/${fieldId}`)
}

export async function sortFields(
  objectId: string,
  fieldOrders: Array<{ field_id: string; sort_order: number }>,
): Promise<ApiResponse<{ success: boolean }>> {
  return apiPut<ApiResponse<{ success: boolean }>, { field_orders: typeof fieldOrders }>(
    `/objects/${objectId}/fields/sort`,
    { field_orders: fieldOrders },
  )
}
